import { useQuery } from '@tanstack/react-query';
import { getSignedDownloadUrl } from '@/shared/api';

/**
 * 대표 이미지의 실제로 열리는 주소 (퀘스트 5519dc5e CP4).
 *
 * `assetPath` 는 저장소 경로라 `<img src>` 에 그대로 넣으면 안 열린다. CP3 까지 캔버스가 그러고
 * 있었고 스토리에서만 온전한 주소를 써서 보이지 않았다.
 *
 * 캔버스와 미리보기가 **같은 주소**를 써야 "보이는 대로 나간다" 가 선다 — 그래서 창 하나가 한 번
 * 풀어 아래로 내려 준다. 작성기와 발송 확인이 같은 키를 쓰므로 한쪽이 푼 주소를 다른 쪽이 받는다.
 * 서명 주소는 만료되므로 오래 붙잡지 않는다.
 */
export const signedImageKeys = {
  one: (assetPath: string) => ['signed-image', assetPath] as const,
};

export function useSignedImageUrl(assetPath: string | null | undefined) {
  const query = useQuery({
    queryKey: signedImageKeys.one(assetPath ?? ''),
    queryFn: () => getSignedDownloadUrl(assetPath as string),
    enabled: typeof assetPath === 'string' && assetPath !== '',
    staleTime: 60_000,
  });
  return query.data ?? null;
}
